<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      
      <div class="page-header">
        <h3 class="page-title">Nhiệm vụ Soạn Hàng Của Tôi</h3>
        <ul class="breadcrumb">
          <li class="breadcrumb-item"><router-link to="/">Dashboard</router-link></li>
          <li class="breadcrumb-item active">Nhiệm vụ của tôi</li>
        </ul>
      </div>

      <div class="card card-tabs mb-3">
        <div class="card-header p-0 border-bottom-0">
          <ul class="nav nav-tabs nav-tabs-bottom">
            <li class="nav-item">
               <a class="nav-link" 
                 :class="{ active: filterTrangThai === 'CHO_SOAN_HANG' }" 
                 href="#" 
                 @click.prevent="setFilter('CHO_SOAN_HANG')">
                  <i class="fa fa-clock-o mr-1"></i> Chờ Soạn Hàng 
                  <span class="badge badge-danger ml-1">{{ choSoanCount }}</span> 
                </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" 
                 :class="{ active: filterTrangThai === 'DA_SOAN_HANG' }" 
                 href="#" 
                 @click.prevent="setFilter('DA_SOAN_HANG')">
                <i class="fa fa-check-square-o mr-1"></i> Đã Soạn Xong
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" 
                 :class="{ active: filterTrangThai === 'DA_DEN' }" 
                 href="#" 
                 @click.prevent="setFilter('DA_DEN')">
                <i class="fa fa-check-square-o mr-1"></i> Bàn giao cho tài xế
              </a>
            </li>
            </ul>
        </div>
      </div>

      <div class="task-list">
        
        <div v-if="isLoading" class="text-center p-4">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2">Đang tải nhiệm vụ...</p>
        </div>
        
        <div v-else-if="listError" class="alert alert-danger text-center">
          {{ listError }}
        </div>
        
        <div v-else-if="!tasks.length" class="alert alert-info text-center">
          Không có nhiệm vụ nào ở trạng thái này.
        </div>

        <div v-for="task in tasks" :key="task.id" class="card task-card" @click="openDetailModal(task)">
          <div class="card-body">
            <div class="row">
              <div class="col-md-8">
                <small class="text-muted">Đơn hàng: {{ task.donHang?.tenDonHang || 'Không rõ' }} (ID: {{ task.donHang?.id }})</small>
                
                <h5 class="task-title mt-1">
                  <i class="fa fa-cube text-primary"></i> Nhiệm vụ: Soạn tại {{ task.tenDiemDung }}
                </h5>
                
                <p class="task-description text-danger font-weight-bold">
                  Vật tư/Ghi chú: {{ task.chiTietVatTu || 'Không có ghi chú' }}
                </p>
                <small class="text-muted">Địa chỉ điểm dừng: {{ task.diaChi || '-' }}</small>
              </div>
              
              <div class="col-md-4 text-right align-self-center">
                <span class="badge" :class="getStopStatusBadge(task.trangThai)">
                  {{ formatStopStatus(task.trangThai) }}
                </span>
                <button class="btn btn-primary btn-sm mt-2 d-block w-100">
                  <i class="fa fa-eye"></i> Xem & Báo cáo
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <KhoDetailModal 
      v-if="selectedTask" 
      :task="selectedTask" 
      @close="closeDetailModal" 
      @report-success="onReportSuccess" 
    />

  </div>
</template>

<script>
// 1. Import Pinia helpers và Store MỚI
import { mapState, mapActions } from 'pinia';
import { useKhoNhiemVuStore } from '@/stores/khoNhiemVuStore'; // <-- Dùng store mới

// 2. Import Modal
import KhoDetailModal from './KhoDetailModal.vue'; 

// 3. Import Helpers
import { getStopStatusBadge, formatStopStatus } from '@/helpers/stopHelpers';
import { lockBodyScroll, unlockBodyScroll } from '@/helpers/dom';

// 4. KHÔNG import apiService ở đây. Store sẽ lo việc đó.

export default {
  name: 'KhoDashboard',
  components: {
    KhoDetailModal
  },
  data() {
    return {
      selectedTask: null, // Chỉ cần quản lý state của Modal
    };
  },
  computed: {
    // 5. Lấy State (dữ liệu) trực tiếp từ Store
    ...mapState(useKhoNhiemVuStore, [
      'isLoading',
      'listError',
      'tasks',            // <-- Lấy danh sách tasks từ store
      'filterTrangThai',  // <-- Lấy trạng thái tab từ store
      'choSoanCount',     // <-- Lấy getter đếm số lượng
    ]),

    // 6. Tính toán số lượng cho tab (lấy từ getter của store)
    choSoanBadge() {
        // Lấy store instance và gọi getter
        // Hoặc map getter nếu muốn
        return useKhoNhiemVuStore().choSoanCount;
    }
  },
  methods: {
    // 7. Lấy Actions (hành động) trực tiếp từ Store
    ...mapActions(useKhoNhiemVuStore, [
      'fetchMyTasks',         // <-- Action để tải data
      'setFilterTrangThai', // <-- Action để đổi tab
    ]),
    
    // 8. Helpers (giữ nguyên)
    getStopStatusBadge,
    formatStopStatus,

    // 9. Hàm setFilter giờ sẽ gọi Action của store
    async setFilter(status) {
      // Gọi action `setFilterTrangThai` đã map ở trên
      await this.setFilterTrangThai(status); 
    },
    
    // 10. Các hàm quản lý Modal (giữ nguyên)
    openDetailModal(task) {
      this.selectedTask = task;
      lockBodyScroll();
    },
    
    closeDetailModal() {
      this.selectedTask = null;
      unlockBodyScroll();
    },
    
    onReportSuccess() {
      this.closeDetailModal();
      // Store đã tự động fetch lại list sau khi báo cáo thành công
      // Không cần gọi fetchMyTasks() nữa, nhưng gọi cũng không sao
    }
  },
  mounted() {
    // 11. Khi component được tải, gọi Action để fetch data
    this.fetchMyTasks();
  }
}
</script>

<style scoped>
.task-card {
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 1rem;
}
.task-card:hover {
  border-color: #007bff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}
.task-description {
  font-size: 1.1rem;
}
.nav-link .badge {
  font-size: 0.8rem;
}
</style>